import { getInitialValues } from "layouts/views/common/common";
import * as Yup from "yup";

const formField = {
  warehouseCode: {
    name: "warehouseCode",
    label: "Warehouse Code",
    type: "select",
    errorMsg: "Warehouse Code is required.",
    required: true,
    editable: false,
    size: 3,
  },
  zoneID: {
    name: "zoneID",
    label: "Zone ID",
    type: "select",
    errorMsg: "Zone ID is required.",
    required: true,
    editable: false,
    size: 3,
  },

  locationID: {
    name: "locationID",
    label: "Location ID",
    type: "text",
    errorMsg: "Location ID is required.",
    required: true,
    editable: false,
    maxLength: 20,
    size: 3,
  },

  descriptions1: {
    name: "descriptions1",
    label: "Descriptions1",
    type: "text",
  },
  descriptions2: {
    name: "descriptions2",
    label: "Descriptions2",
    type: "text",
  },

  aisle: {
    name: "aisle",
    label: "Aisle",
    type: "text",
  },
  locDimGrp: {
    name: "locDimGrp",
    label: "Location Group",
    type: "select",
  },

  rack: {
    name: "rack",
    label: "Rack",
    type: "text",
  },
  locationType: { name: "locationType", label: "Location Type", type: "select" },

  lLevel: {
    name: "lLevel",
    label: "Level",
    type: "number",
  },
  locCategory: { name: "locCategory", label: "Location Category", type: "select" },

  bay: {
    name: "bay",
    label: "Bay",
    type: "number",
  },
  dropZone: { name: "dropZone", label: "Drop Zone", type: "text" },

  slot: {
    name: "slot",
    label: "Slot",
    type: "number",
  },
  mheType: { name: "mheType", label: "MHE Type", type: "select" },

  movementType: { name: "movementType", label: "Movement Type", type: "select" },

  smallPallet: { name: "smallPallet", label: "Small Pallet Qty", type: "number" },
  standardPallet: { name: "standardPallet", label: "Standard Pallet Qty", type: "number" },
  largePallet: { name: "largePallet", label: "Large Pallet Qty", type: "number" },

  mixDates: {
    name: "mixDates",
    label: "Mix Dates",
    type: "switch",
    default: false,
  },
  mixMLN: {
    name: "mixMLN",
    label: "Mix MLN",
    type: "switch",
    default: false,
  },
  mixOLN: {
    name: "mixOLN",
    label: "Mix OLN",
    type: "switch",
    default: false,
  },

  mixPart: {
    name: "mixPart",
    label: "Mix SKU",
    type: "switch",
    default: false,
  },
  mixVendor: {
    name: "mixVendor",
    label: "Mix Vendor",
    type: "switch",
    default: false,
    size: 3,
  },
  mixCustomer: {
    name: "mixCustomer",
    label: "Mix Customer",
    type: "switch",
    default: false,
    size: 3,
  },

  openLoc: {
    name: "openLoc",
    label: "Open Location",
    type: "switch",
    default: false,
    size: 3,
  },
};

const {
  warehouseCode,
  zoneID,
  locationID,
  descriptions1,
  descriptions2,
  aisle,
  locDimGrp,
  dropZone,
  rack,
  lLevel,
  bay,
  slot,
  smallPallet,
  standardPallet,
  largePallet,
  movementType,
  locationType,
  mheType,
  locCategory,
  mixDates,
  mixMLN,
  mixOLN,
  mixPart,
  mixVendor,
  mixCustomer,
  openLoc,
} = formField;
export const form = {
  formId: "new-location-form",
  formRender: [
    [
      {
        name: "warehouseCode",
        label: "Warehouse Code",
        type: "select",
        errorMsg: "Warehouse Code is required.",
        required: true,
        disabled: true,
        xs: 6,
      },
      {
        name: "zoneID",
        label: "Zone ID",
        type: "select",
        errorMsg: "Zone ID is required.",
        required: true,
        disabled: true,
        xs: 6,
      },
    ],
    [
      {
        name: "locationID",
        label: "Location ID",
        type: "text",
        errorMsg: "Location ID is required.",
        required: true,
        disabled: true,
        xs: 6,
        maxLength: 20,
      },
    ],
    [
      {
        name: "descriptions1",
        label: "Descriptions1",
        type: "text",
        xs: 6,
      },
      {
        name: "descriptions2",
        label: "Descriptions2",
        type: "text",
        xs: 6,
      },
    ],
    [
      {
        name: "aisle",
        label: "Aisle",
        type: "text",
      },
      {
        name: "locDimGrp",
        label: "Location Group",
        type: "text",
      },
    ],
    [
      {
        name: "rack",
        label: "Rack",
        type: "text",
      },
      { name: "locationType", label: "Location Type", type: "select" },
    ],
    [
      {
        name: "lLevel",
        label: "Level",
        type: "number",
      },
      { name: "locCategory", label: "Location Category", type: "select" },
    ],
    [
      {
        name: "bay",
        label: "Bay",
        type: "number",
      },
      { name: "dropZone", label: "Drop Zone", type: "text" },
    ],
    [
      {
        name: "slot",
        label: "Slot",
        type: "number",
      },
      { name: "mheType", label: "MHE Type", type: "select" },
    ],

    [{ name: "movementType", label: "Movement Type", type: "select", xs: 6 }],

    [
      { name: "smallPallet", label: "Small Pallet Qty", type: "number" },
      { name: "standardPallet", label: "Standard Pallet Qty", type: "number" },
      { name: "largePallet", label: "Large Pallet Qty", type: "number" },
    ],

    [
      {
        name: "mixDates",
        label: "Mix Dates",
        type: "switch",
        default: false,
      },
      {
        name: "mixMLN",
        label: "Mix MLN",
        type: "switch",
        default: false,
      },
      {
        name: "mixOLN",
        label: "Mix OLN",
        type: "switch",
        default: false,
      },
    ],
    [
      {
        name: "mixPart",
        label: "Mix SKU",
        type: "switch",
        default: false,
      },
      {
        name: "mixVendor",
        label: "Mix Vendor",
        type: "switch",
        default: false,
      },
      {
        name: "mixCustomer",
        label: "Mix Customer",
        type: "switch",
        default: false,
      },
    ],
    [
      {
        name: "openLoc",
        label: "Open Location",
        type: "switch",
        default: false,
        //xs:4
        xs: 4,
      },
    ],
  ],
};

export const formRender = [
  [warehouseCode, zoneID, locationID],
  [aisle, rack, descriptions1, descriptions2],
  [locDimGrp, locationType, locCategory, dropZone],
  [lLevel, bay, slot, mheType],
  [smallPallet, standardPallet, largePallet, movementType],
  [mixDates, mixMLN, mixOLN, mixPart],
  [mixVendor, mixCustomer, openLoc],
];

// function getInitialValues(formField) {
//   let initialValues = {};
//   formField.forEach((field) => {
//     field.forEach((x) => {
//       if (x.type === "text") {
//         initialValues[x.name] = "";
//       } else if (x.type === "select") {
//         initialValues[x.name] = null;
//       } else if (x.type === "number") {
//         initialValues[x.name] = 0;
//       } else if (x.type === "switch") {
//         initialValues[x.name] = x.default;
//       }
//     });
//   });
//   return initialValues;
// }

// function getFormField(formField) {
//   let initialFormField = {};
//   formField.forEach((field) => {
//     field.forEach((x) => {
//       initialFormField[x.name] = x;
//     });
//   });
//   return initialFormField;
// }

export const initialValues = getInitialValues(formField);

export const locationValidations = Yup.object().shape({
  [warehouseCode.name]: Yup.string().nullable().max(20).required(warehouseCode.errorMsg),
  [zoneID.name]: Yup.string().nullable().max(20).required(zoneID.errorMsg),
  [locationID.name]: Yup.string().nullable().max(20).required(locationID.errorMsg),
  [aisle.name]: Yup.string().nullable().max(20),
  [rack.name]: Yup.string().nullable().max(20),
  [lLevel.name]: Yup.number().min(0),
  [bay.name]: Yup.number().min(0),
  [slot.name]: Yup.number().min(0),
  [smallPallet.name]: Yup.number().min(0),
  [standardPallet.name]: Yup.number().min(0),
  [largePallet.name]: Yup.number().min(0),
  [movementType.name]: Yup.string().nullable(),
  [locationType.name]: Yup.string().nullable(),
  [mheType.name]: Yup.string().nullable(),
  [locCategory.name]: Yup.string().nullable(),
});
